import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import {addYears} from "date-fns";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {selectServiceApply} from "../../../api/serviceRequest/ServiceApplyService";
import ServiceApplyListType from "./subpage/ServiceApplyListType";
import {useDispatch} from "react-redux";
import useRequestData from "../../../hooks/useRequestData";
import ServiceApplyThumbType from "./subpage/ServiceApplyThumbType";
import MobileCreateButton from "../../../components/buttons/MobileCreateButton";

const ServiceApplyList = () => {
    const [listType, setListType] = useState(true);
    const dp = useDispatch();

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    const {data, newData, pageInfo, dataHook} = useRequestData(selectServiceApply, initDate, "service_apply");

    return (
        <div className={"common-container"}>
            <PageHeader header={"서비스신청"} indicator={"서비스요청 > 서비스신청"} />
            {listType ?
                <ServiceApplyListType data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook} />
                :
                <ServiceApplyThumbType data={data} date={initDate} pageInfo={pageInfo} dataHook={dataHook} />
            }

            <MobileCreateButton  url={'/serviceRequest/serviceApply/create'} userCheck />
        </div>
    );
};

export default ServiceApplyList;